<template lang="pug">
.main
  div.d-flex.mt-4.align-center
    v-img.mt-2.ml-2(:src="require('@/assets/images/logo_main.png')" max-height="40" max-width="100" contain)
    v-spacer
    v-menu(:offset-y='true')
      template(v-slot:activator='{ on }')
        v-btn.button-Aa-medium.mr-1(text v-on="on" small)
          span {{ selectedLang.name }}
          v-card.ml-2(tile)
            v-img(:src="require(`@/assets/images/flags/${selectedLang.flag}.png`)" width="26px" height="14px")
      v-list
        template(v-for="lang in languages")
          v-list-item(dense :key='lang.code' @click="language = lang.code")
            v-list-item-title(v-text="lang.name")
            v-list-item-icon(v-if="lang.code === language")
              v-icon(color="success" v-text="'mdi-check-bold'")
  v-layout.mt-n12(style="height:100vh")
    v-container.my-auto(style="max-width: 600px;" outlined)
      div(v-if="!(email || phone)")
        template(v-if="step === 1")
          v-card.mx-3.mt-4( flat outlined )
            h5.text-center.my-8.grey--text.text--darken-3 {{ $t('create_an_account') }}
            v-card.mt-0.pb-5( flat :tile="this.$vuetify.breakpoint.xs")
              .normal
                v-card-text.pt-0(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
                  v-btn.mb-4.font-weight-bold.button-AA-medium.white--text.px-0(v-if="!$isMobile" color="info500" x-large block depressed @click="continueGoogleSignUp" height="40" :loading="googleSignUpLoading")
                    v-icon(left small) mdi-google
                    | {{ $t('one_click_signup_gmail') }}
                  template
                    div.text-center.mb-4(v-if="!$isMobile") {{ $t('or') }}
                    y-phone-input.my-4(v-if="signupMethod === 'phone'" v-model="phoneEmail")
                    v-text-field.p1.my-4(v-else-if="signupMethod === 'email'" v-model="phoneEmail" :error-messages="phoneFieldError" @keyup.enter="sendVerifyCode" :rules="rules.email" outlined hide-details="auto" dense solo flat background-color="basic200" height="40")
                      template(v-slot:label)
                        .p1.basic600--text {{ $t('enter_email') }}
                    div.c2.text-center.info500--text.clickable(@click="changeSignupMethod(signupMethod)") {{ $t('change_to') }} {{ signupMethod === 'phone' ? 'email' : 'phone number' }}
                    v-btn.button-AA-medium.mt-4.mb-4.px-4.elevation-0(color="info500" block dark depressed @click="sendVerifyCode" :loading="loading") {{ $t('sign_up') }}
                    div.mt-4.text-center
                      h6.p2.text-center(style="color: #848484;") {{ $t('you_will_receive') + ' or SMS' }} {{ $t('to_proceed_signing_up') }}
          div.mt-6.text-center
            h6.c2.text-center(style="color: #848484; font-weight:600;") {{ $t('already_have_account') }}
              span.cursor-pointer.info500--text(text @click="$router.push('/signin')")  {{ $t('log_in') }}.
        template(v-if="step === 2")
          div.mx-3
            v-alert(color="info500")
              v-row
                v-col.pr-0(cols="3")
                  v-card.text-center.align-center.justify-center(flat style="width:40px ; height;40px")
                    eva-icon.pt-1(name="email-outline" :fill="$vuetify.theme.themes[$theme].info500")
                v-col.pl-0.text-left.align-left(cols="9")
                  h6.s1.white--text {{ $t('check_email_inbox') }}
                  h6.c1.white--text {{ $t('check_email_inbox_desc') }}
          v-card.mt-4.px-2.py-4.mx-3(outlined :tile="$vuetify.breakpoint.xs")
            v-card-text(:class="{'pb-0': $vuetify.breakpoint.xs}")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('email_address') }}
              v-text-field.p1.pt-2(color="basic500" v-model="form.email" label="E-mail address" hide-details outlined disabled dense solo flat background-color="basic200" height="40")
                eva-icon(slot="append" name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
              template(v-if="emailAuthInProgress")
                v-layout.my-4(v-if="emailAuthWaiting")
                  div.mx-auto
                    v-layout
                      v-progress-circular.my-auto(indeterminate :size="16" :width="2" color="info500")
                      .p2.my-auto.ml-3 {{ $t('waiting_for_your_approval') }}...
                div(v-else)
                  v-layout.my-4(v-if="emailAuthSuccess")
                    div.mx-auto
                      v-layout
                        eva-icon.mb-n1(name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
                        .p2.ml-3.my-auto {{ $t('sign_in_approved_continue_in') }} {{emailAuthCloseTimer}}...
                  v-layout.my-4(v-else)
                    div.mx-auto
                      v-layout
                        eva-icon.mb-n1(name="close-circle-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].danger500")
                        .p2.ml-3.my-auto {{ $t('approval_link_expired') }},&nbsp;
                          a.info500--text.cursor-pointer(@click="requestEmailAuthLink") {{ $t('click_here_to_request') }}
                          | .
              v-divider.mt-12.mb-n3
              v-layout.mb-8
                div.mx-auto.px-3.basic100
                  .s2.primary400--text {{ $t('or') }}
              v-layout
                label.basic600--text.text-uppercase {{ $t('log_in_with_password') }}
                v-spacer
                .c1(@click="$router.push({ name: 'Forgot', params: { signInEmail: form.email } })") {{ $t('forgot_password') }}
              v-text-field.pt-2(color="primary" v-model="form.password" type="password"  @keyup.enter="passwordSignIn" persistent-hint outlined dense solo flat background-color="basic200"    height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('password') }}
              v-btn.mb-4.button-AA-medium.white--text(color="info500" x-large block depressed @click="passwordSignIn" :loading="passwordSignInLoading") {{ $t('log_in') }}
          div.mx-6.mt-10.text-center
            a.button-Aa-small.primary400--text(@click="step--") &#8592; {{ $t('back') }}

      div(v-else)
        h5.text-center.mb-4.mt-16.grey--text.text--darken-3 {{ $t('lets_create_your_account') }}
        v-card.mt-4.pb-8(flat :tile="this.$vuetify.breakpoint.xs" :class="{'px-8': !this.$vuetify.breakpoint.xs}")
          v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
            v-form(ref="form" v-model="valid")
              p.mb-1.label.basic600--text.text-uppercase(v-if="email && !phone") {{ $t('email_address') }}
              v-text-field.mt-2(v-if="email && !phone" color="primary"  type="email" label="E-mail address" :disabled="true" outlined dense solo flat background-color="basic200"  height="40")
                template(v-slot:label v-model="form.email")
                  .p1.basic500--text(style="color: #c1c1c1;") {{form.email}}
                eva-icon(slot="append" name="checkmark-circle-2-outline" width="20" height="20" :fill="$vuetify.theme.themes[$theme].success400")
              p.mb-1.label.basic600--text.text-uppercase(v-if="phone") {{ $t('phone_number') }}
              y-phone-input.my-4(v-model="form.phone")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('first_name') }}
              v-text-field.mt-2(color="primary" v-model="form.first_name" type="text"  :rules="rules.first_name" dense solo flat background-color="basic200" outlined height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('first_name_placeholder') }}
              p.mb-1.label.basic600--text.text-uppercase {{ $t('last_name') }}
              v-text-field.mt-2(color="primary" v-model="form.last_name" type="text" :rules="rules.last_name" dense solo flat background-color="basic200" outlined   height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('last_name_placeholder') }}
              template(v-if="email && !phone && !googleToken")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('password') }}
                v-text-field.mt-2(color="primary" v-model="form.password" type="password" :rules="rules.password" outlined dense solo flat background-color="basic200"    height="40")
                  template(v-slot:label)
                    .p1.basic600--text {{ $t('password_placeholder') }}
              p.mb-1.label.basic600--text.text-uppercase(v-if="phone") {{ $t('email_address_optional') }}
              v-text-field.mt-2(v-if="phone" color="primary" v-model="form.email" type="email" :error-messages="emailFieldError" persistent-hint hint="You will receive Yezza training material and order notification" outlined dense solo flat background-color="basic200"   height="40")
                template(v-slot:label)
                  .p1.basic600--text {{ $t('email_address_optional_placeholder') }}
              y-checkbox.mt-4(v-model="agreedTerm" :rules="rules.agreedTerm")
                template(v-slot:label)
                  span.h6.p2.primary400--text
                    | {{ $t('i_agree_to') }} Yezza&nbsp;
                    a.h6.p2.info500--text(href="https://yezza.io/term-of-use/") {{ $t('terms') }}
                    | &nbsp;{{ $t('and') }}&nbsp;
                    a.h6.p2.info500--text(href="https://yezza.io/privacy-policy/") {{ $t('privacy_policy') }}
              y-checkbox.mt-0(v-model="waOptin")
                template(v-slot:label)
                  span.h6.p2.primary400--text {{ $t('i_agree_receive_notification') }}
              v-btn.button-AA-medium.white--text(color="info500" x-large block depressed @click="submit" :loading="loading" height="40" :disabled="!agreedTerm") {{ $t('create_account') }}

    .modals
      y-dialog(v-model='phoneAuthInProgress' persistent width='300')
        v-card(v-if="phoneAuthWaiting" color='primary' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('check_your_phone') }} {{phoneEmail}}.
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('waiting_for_your_approval') }}...
          v-card-actions
            v-spacer
            v-btn(text :disabled="resendOTPTimer > 0" @click="requestPhoneAuthLink")
              span(v-if="resendOTPTimer > 0") {{ $t('resend') }} ({{ resendOTPTimer}})
              span(v-else) {{ $t('resend') }}
        template(v-else)
          v-card(v-if="phoneAuthSuccess" color='success' dark)
            v-card-text.pt-3
              p.mt-2 {{ $t('sign_in_approved') }}
              v-progress-linear.my-4(indeterminate='', color='white')
              p.mb-0.caption {{ $t('continue_in') }} {{phoneAuthCloseTimer}}...

          v-card(v-else color='error' dark)
            v-card-text.pt-3
              p.mt-2 {{ $t('sign_in_not_approved') }}
              v-progress-linear.my-4(indeterminate='', color='white')
              p.mb-0.caption {{ $t('closing_in') }} {{phoneAuthCloseTimer}}...
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import Cookies from 'js-cookie'
import TopBar from '@/components/TopBar'

export default {
  name: 'SignUpDonation',
  components: { TopBar },
  props: ['email', 'phone', 'code'],
  data: () => ({
    loading: false,
    agreedTerm: false,
    signupMethod: 'phone',
    waOptin: false,
    valid: false,
    phoneEmail: '',
    phoneFieldError: '',
    emailFieldError: '',
    googleSignUp: false,
    googleToken: null,
    googleSignUpLoading: false,
    phoneAuthInProgress: false,
    phoneAuthWaiting: false,
    phoneAuthSuccess: false,
    phoneAuthProgressTimer: 0,
    phoneAuthCloseTimer: 0,
    resendOTPTimer: 0,
    step: 1,
    emailAuthInProgress: false,
    emailAuthWaiting: false,
    emailAuthSuccess: false,
    emailAuthProgressTimer: 0,
    emailAuthCloseTimer: 0,
    passwordSignInLoading: false,
    form: {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      phone: null,
      otp: null
    },
    passwordFieldError: '',
    projectId: null,
    language: null,
    languages: [
      { name: 'English', code: 'en', flag: 'gb' },
      { name: 'Bahasa Indonesia', code: 'id', flag: 'id' },
    ],
    rules: {
      first_name: [
        v => !!v || 'First name is required'
      ],
      last_name: [
        v => !!v || 'Last name is required'
      ],
      phoneEmail: [
        v => !!v || 'Phone number or e-mail address is required'
      ],
      email: [
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      postcode: [
        v => !!v || 'Postcode is required'
      ],
      password: [
        v => !!v || 'Password is required',
        v => v.length >= 8 || 'Password must be 8 or more characters',
      ],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ]
    }
  }),
  computed: {
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
    authMethod () {
      return this.phoneEmail.includes('@') ? 'email': 'phone'
    },
    selectedLang () {
      let lang = this.languages.find(f => f.code === this.language)
      return lang || { name: 'English', code: 'en', flag: 'gb' }
    }
  },
  watch: {
    'form.email'() {
      this.emailFieldError = ''
    },
    language (val) {
      if (!val || val === 'undefined' || val === 'null') {
        this.$store.commit('language/setLanguage', 'en')
        this.language = 'en'
      } else {
        this.$store.commit('language/setLanguage', val)
      }
    },
    phoneAuthCloseTimer (val) {
      if (val === 0) {
        this.phoneAuthInProgress = false
      }
    },
  },
  mounted () {
    this.handleGoogleSignUpCallback()
    this.language = this.lang
    if (this.phone) {
      this.$set(this.form, 'phone', this.phone)
    }
    if (this.email) {
      this.$set(this.form, 'email', this.email)
    }
    // Affiliate
    const afId = this.$route.query.af_id
    if (afId) {
      const currentAfId = Cookies.get('af_id')
      if (currentAfId != afId) {
        Cookies.set('af_id', afId, { expires: 30 })
      }
      let query = {...this.$route.query}
      delete query.af_id
      this.$router.replace({ query })
    }
    const afIdCookie = Cookies.get('af_id')
    this.$store.commit('ui/setAffiliateId', afIdCookie)
    
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleVerification(phoneEmail) {
      this.phoneEmail = phoneEmail
      this.sendVerifyCode()
    },
    sendVerifyCode () {
      if (!this.phoneEmail) {
        return
      }
      this.phoneFieldError = ''
      this.loading = true
      if (this.$route.query.project) {
        Cookies.set('project_id', this.$route.query.project, { expires: 1 })
      }

      if (this.authMethod === 'email') {
        // this.phoneFieldError = 'Phone number must be valid'
        // this.loading = false
        // return
        this.form.email = this.phoneEmail
        let emailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.phoneEmail)
        if (!emailValid) {
          this.phoneFieldError = 'E-mail must be valid'
          this.loading = false
          return
        }
        this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
          .then(resp => {
            if (resp.data.available) {
              this.$axios.post('/users/send_verification_code/', { email: this.form.email })
                .then(() => {
                  this.$router.push({ name: 'Verify', params: { email: this.form.email, pushTo: 'SignUpDonation' }})
                })
                .catch((err) => {
                  let msg = this.$t('error_message.unable_to_complete_request')
                  if (err.response.data[0]) {
                    msg = err.response.data[0]
                  }
                  this.showMessage(['error', msg])
                })
                .finally(() => {
                  this.loading = false
                })
            } else {
              if (resp.data.verified) {
                this.form.email = this.phoneEmail
                this.step = 2
                this.requestEmailAuthLink()
              } else {
                this.showMessage(['error', this.$t('error_message.this_email_must_verified')])
              }
            }
          }).catch(() => {})
      } else if (this.authMethod === 'phone') {
        this.form.phone = this.phoneEmail
        this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(this.form.phone)}`)
          .then(resp => {
            if (resp.data.available) {
              this.$axios.post('/users/request_otp/', { phone: this.form.phone })
                .then(() => {
                  this.$router.push({ name: 'Verify', params: { phone: this.form.phone, pushTo: 'SignUpDonation' }})
                })
                .catch((err) => {
                  let msg = this.$t('error_message.unable_to_complete_request')
                  if (err.response.data[0]) {
                    msg = err.response.data[0]
                  }
                  this.showMessage(['error', msg])
                })
                .finally(() => {
                  this.loading = false
                })
            } else {
              this.requestPhoneAuthLink()
            }
          }).catch(() => {})
      }
    },
    async submit () {
      this.valid = true
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.loading = true
      let form = {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        fbq: {
          cookies: Cookies.get(),
          user_agent: navigator.userAgent
        }
      }
      if (this.email) {
        form.email = this.form.email
        if (this.googleSignUp) {
          form.google_token = this.googleToken
        } else {
          form.password = this.form.password
          form.code = this.code
        }
      } else if (this.phone) {
        if (this.form.email) {
          let emailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.form.email)
          if (!emailValid) {
            this.emailFieldError = 'E-mail must be valid'
            this.loading = false
            return
          }

          let emailCheckResp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.form.email)}`)
          if (emailCheckResp.data.available) {
            form.email = this.form.email
          } else {
            this.emailFieldError = 'E-mail not available. Choose different email.'
            this.loading = false
            return
          }

          form.email = this.form.email
        }
        form.phone = this.form.phone
        form.otp_verified_token = this.code
      }
      if (this.projectId) {
        form['sponsor'] = this.projectId

      }
      try {
        let userCreateResp = await this.$axios.post('/users/', form)
        this.$store.commit('user/setUser', userCreateResp.data)
        if (this.waOptin) {
          this.$axios.patch(`/users/${userCreateResp.data.id}/`, { whatsapp_optin: true })
            .then(resp => {
              this.$store.commit('user/setUser', resp.data)
            })
            .catch(() => {})
        }
        this.trackPixel(userCreateResp.data.id)
        this.trackGtag()
        this.$router.push('/start/donation')
      } catch (e) {
        if (e.response) {
          if (e.response.data.email) {
            this.showMessage(['error', e.response.data.email[0]])
          }
          if (e.response.data.password) {
            this.showMessage(['error', e.response.data.password[0]])
          }
        }
      } finally {
        this.loading = false
      }
    },
    async continueGoogleSignUp () {
      const redirectUri = window.location.origin + '/signup/donation'
      const nonce = (Math.random() + 1).toString(36).substring(2)
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.VUE_APP_GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&state=google&response_type=id_token&nonce=${nonce}&scope=profile email`
    },
    async handleGoogleSignUpCallback () {
      if (!this.$route.hash) return
      let qs = new URLSearchParams(this.$route.hash.substring(1))
      let googleToken = qs.get('id_token')
      if (qs.get('state') === 'google' && googleToken) {
        this.googleSignUpLoading = true
        try {
          let resp = await this.$axios.get(`https://oauth2.googleapis.com/tokeninfo?id_token=${googleToken}`)
          if (resp.data.email && resp.data.email_verified) {
            let emailCheckResp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(resp.data.email)}`)
            if (!emailCheckResp.data.available) {
              let resp = await this.$axios.post('/users/token/', { google_token: qs.get('id_token') })
              this.completeSignIn(resp.data, 'google')
              return
            }

            this.form.email = resp.data.email
            this.form.first_name = resp.data.given_name
            this.form.last_name = resp.data.family_name
            this.googleToken = googleToken
            this.email = resp.data.email
            this.googleSignUp = true
          }
        } catch (err) {
          this.showMessage(['error', err.response.data])
        } finally {
          this.googleSignUpLoading = false
        }
      }
    },
    async requestPhoneAuthLink () {
      try {
        let resp = await this.$axios.post('/users/request_auth_link/', { phone: this.phoneEmail, language: this.lang })
        this.phoneAuthWaiting = true
        this.phoneAuthInProgress = true
        this.phoneAuthProgressTimer = 300
        const interval = setInterval(() => {
          this.phoneAuthProgressTimer--
          if (this.phoneAuthProgressTimer === 0) {
            this.phoneAuthWaiting = false
            this.phoneAuthSuccess = false
            this.phoneAuthCloseTimer = 5
            const closeInterval = setInterval(() => {
              this.phoneAuthCloseTimer--
              if (this.phoneAuthCloseTimer <= 0) {
                this.phoneAuthInProgress = false
                this.loading = false
                clearInterval(closeInterval)
              }
            }, 1000)
            clearInterval(interval)
          }
        }, 1000)
        this.resendOTPTimer = 30
        const resendInterval = setInterval(() => {
          this.resendOTPTimer--
          if (this.resendOTPTimer === 0) {
            clearInterval(resendInterval)
          }
        }, 1000)
        this.authLinkRecheckCount = 0
        const manualCheckInterval = setInterval(() => {
          this.authLinkRecheckCount++
          if (this.authLinkRecheckCount >= 60) {
            clearInterval(manualCheckInterval)
          }
          this.$axios.get('/users/check_auth_link/', { params: { token: resp.data.token } })
          .then(r => {
            this.phoneAuthSuccess = true
            this.phoneAuthWaiting = false
            this.phoneAuthCloseTimer = 4
            const interval = setInterval(() => {
              this.phoneAuthCloseTimer--
              if (this.phoneAuthCloseTimer === 0) {
                this.completeSignIn(r.data, 'authlink_sms')
                clearInterval(interval)
              }
            }, 1000)
            clearInterval(manualCheckInterval)
          })
          .catch(() => {})
        }, 5000)
        this.$wamp.subscribe(`auth-link:${resp.data.token}`, (args, kwArgs) => {
          this.phoneAuthSuccess = true
          this.phoneAuthWaiting = false
          this.phoneAuthCloseTimer = 4
          const interval = setInterval(() => {
            this.phoneAuthCloseTimer--
            if (this.phoneAuthCloseTimer === 0) {
              this.completeSignIn(kwArgs.data, 'authlink_sms')
              clearInterval(interval)
            }
          }, 1000)
        })
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_phone_number')])
        this.loading = false
      }
    },
    async requestEmailAuthLink () {
      try {
        let resp = await this.$axios.post('/users/request_auth_link/', { email: this.phoneEmail, language: this.lang })
        this.emailAuthWaiting = true
        this.emailAuthInProgress = true
        this.emailAuthProgressTimer = 300
        const interval = setInterval(() => {
          this.emailAuthProgressTimer--
          if (this.emailAuthProgressTimer === 0) {
            this.emailAuthWaiting = false
            this.emailAuthSuccess = false
            this.emailAuthCloseTimer = 5
            const closeInterval = setInterval(() => {
              this.emailAuthCloseTimer--
              if (this.emailAuthCloseTimer <= 0) {
                clearInterval(closeInterval)
              }
            }, 1000)
            clearInterval(interval)
          }
        }, 1000)
        this.authLinkRecheckCount = 0
        const manualCheckInterval = setInterval(() => {
          this.authLinkRecheckCount++
          if (this.authLinkRecheckCount >= 60) {
            clearInterval(manualCheckInterval)
          }
          this.$axios.get('/users/check_auth_link/', { params: { token: resp.data.token } })
          .then(r => {
            this.emailAuthSuccess = true
            this.emailAuthWaiting = false
            this.emailAuthCloseTimer = 4
            const interval = setInterval(() => {
              this.emailAuthCloseTimer--
              if (this.emailAuthCloseTimer === 0) {
                this.completeSignIn(r.data, 'authlink_email')
                clearInterval(interval)
              }
            }, 1000)
            clearInterval(manualCheckInterval)
          })
          .catch(() => {})
        }, 5000)
        this.$wamp.subscribe(`auth-link:${resp.data.token}`, (args, kwArgs) => {
          this.emailAuthSuccess = true
          this.emailAuthWaiting = false
          this.emailAuthCloseTimer = 4
          const interval = setInterval(() => {
            this.emailAuthCloseTimer--
            if (this.emailAuthCloseTimer === 0) {
              this.completeSignIn(kwArgs.data, 'authlink_email')
              clearInterval(interval)
            }
          }, 1000)
        })
      } catch {
        this.showMessage(['error', this.$t('error_message.no_account_associated_email')])
      }
    },
    async passwordSignIn () {
      this.passwordSignInLoading = true
      try {
        const data = {
          email: this.form.email,
          password: this.form.password
        }
        let resp = await this.$axios.post('/users/token/', data)
        this.completeSignIn(resp.data, 'password')
      } catch {
        this.showMessage(['error', this.$t('error_message.invalid_email_or_password')])
      } finally {
        this.passwordSignInLoading = false
      }
    },
    completeSignIn (respData, signInMethod = null) {
      this.$store.commit('user/setUser', respData)
      this.$axios.defaults.headers.common['Authorization'] = `Token ${respData.token}`
      if (signInMethod) {
        this.$logEvent('user.signed_in', { method: signInMethod })
      }
      this.$router.push('/start/donation')
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.event('generate_lead')
      })
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Lead', null, {eventID: eventID})
    },
    changeSignupMethod (val) {
      this.phoneEmail = ''
      if (val === 'phone') {
        this.signupMethod = 'email'
      } else if (val === 'email') {
        this.signupMethod = 'phone'
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "already_have_account": "Already have an account?",
    "and": "and",
    "approval_link_expired": "Approval link has expired",
    "check_email_inbox": "Check your e-mail inbox.",
    "check_email_inbox_desc": "We've sent an email with an approval link.",
    "check_your_phone": "Check your phone. We've sent a SMS with an approval link to",
    "click_here_to_request": "click here to request again",
    "closing_in": "Closing in",
    "continue_in": "Continue in",
    "create_an_account": "Create an account",
    "email_address_optional": "Email Address (Optional)",
    "email_address_optional_placeholder": "Enter your email address",
    "enter_phone_number": "Enter Phone Number",
    "enter_phone_number_email": "Enter Phone number or Email Address",
    "first_name": "First Name",
    "first_name_placeholder": "Enter your first name",
    "forgot_password": "Forgot password?",
    "i_agree_receive_notification": "I agree to receive notification and promotion messages via WhatsApp",
    "i_agree_to": "I agree to",
    "last_name": "Last Name",
    "last_name_placeholder": "Enter your last name",
    "lets_create_your_account": "Let's create your account",
    "log_in_to": "Log in to",
    "log_in_with_google": "Log In with Google",
    "log_in_with_password": "Log in with password",
    "new_to_yezza": "New to Yezza?",
    "one_click_signup_gmail": "ONE-CLICK SIGNUP WITH GMAIL",
    "password": "Password",
    "password_placeholder": "Create a password",
    "privacy_policy": "Privacy Policy",
    "sign_in_approved": "Sign in approved",
    "sign_in_approved_continue_in": "Sign in approved. Continue in",
    "sign_in_not_approved": "Sign in not approved in time",
    "sign_in_to": "Sign in to",
    "sign_up": "SIGN UP",
    "sign_up_now": "Sign up now",
    "terms": "Terms",
    "to_proceed_signing_up": "to proceed with signing up.",
    "waiting_for_your_approval": "Waiting for your approval",
    "you_will_receive": "You will receive an email",
    "you_will_receive_email_sms": "You will receive an email or SMS to proceed with signing in."
},
  "id": {
    "already_have_account": "Sudah punya akun?",
    "and": "dan",
    "approval_link_expired": "Link approval telah kadaluwarsa",
    "check_email_inbox": "Periksa email kamu.",
    "check_email_inbox_desc": "Kami telah menghantar email bersama link approval.",
    "check_your_phone": "Periksa telepon mu. Kami telah mengirim SMS dengan link approval ke",
    "click_here_to_request": "klik di sini untuk meminta lagi",
    "closing_in": "Closing in",
    "continue_in": "Continue in",
    "create_an_account": "Buat akun",
    "email_address_optional": "Alamat Email (Opsional)",
    "email_address_optional_placeholder": "Masukkan alamat email kamu",
    "enter_phone_number": "Masukkan Nomor Telepon",
    "enter_phone_number_email": "Masukkan nomor HP atau email",
    "first_name": "Nama Depan",
    "first_name_placeholder": "Masukkan nama depan kamu",
    "forgot_password": "Lupa kata sandi?",
    "i_agree_receive_notification": "Saya setuju untuk menerima pesan pemberitahuan dan promosi melalui WhatsApp",
    "i_agree_to": "Saya setuju",
    "kata sandi": "Kata sandi",
    "last_name": "Nama Belakang",
    "last_name_placeholder": "Masukkan nama belakang kamu",
    "lets_create_your_account": "Ayo buat akun kamu",
    "log_in_to": "Log in ke",
    "log_in_with_google": "Log in lewat Google",
    "log_in_with_password": "Log in menggunakan kata sandi",
    "new_to_yezza": "Pengguna Baru?",
    "one_click_signup_gmail": "DAFTAR SATU-KLIK DENGAN GMAIL",
    "password": "Kata sandi",
    "password_placeholder": "Buat kata sandi",
    "privacy_policy": "Kebijakan Privasi",
    "sign_in_approved": "Sign in approved",
    "sign_in_approved_continue_in": "Masuk disetujui. Lanjutkan di",
    "sign_in_not_approved": "Sign in not approved in time",
    "sign_in_to": "Log in ke",
    "sign_up": "DAFTAR",
    "sign_up_now": "Daftar sekarang",
    "terms": "Persyaratan",
    "to_proceed_signing_up": "untuk melanjutkan pendaftaran.",
    "waiting_for_your_approval": "Menunggu approval kamu",
    "you_will_receive": "Anda akan menerima email",
    "you_will_receive_email_sms": "Anda akan menerima email atau SMS untuk Log in."
  }
}
</i18n>